<template>
<div>
    <!-- loader -->
    <Loader />
    <!-- loader -->

    <!-- login-area -->
    <section class="login-area">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="form-area">
                        <div class="login-form">
                            <div class="form-logo">
                                <router-link to="/"><img class="img-fluid" src="@/assets/img/logo.svg" alt="logo"></router-link>
                                <h3>Let’s verify!</h3>
                            </div>
                            <form @submit.prevent="forgotCheckOTP" name="verifyForm" class="verify" data-wow-duration="1s" data-wow-delay="1s">
                                <div class="inputs">
                                    <input type="text" v-model="OTPParams.n1" maxLength="1" ref="otp1">
                                    <input type="text" v-model="OTPParams.n2" maxLength="1">
                                    <input type="text" v-model="OTPParams.n3" maxLength="1">
                                    <input type="text" v-model="OTPParams.n4" maxLength="1">
                                    <input type="text" v-model="OTPParams.n5" maxLength="1">
                                    <input type="text" v-model="OTPParams.n6" maxLength="1">
                                </div>
                                <button class="login-btns" type="submit" value="Submit">Verify </button>
                            </form>
                            <p class="dont-acc">Didn't receive it? <a href="javascript:;" @click="forgotSubmit">Resend code </a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- login-area -->
</div>
</template>

<script>
import $ from "jquery";
import {
    ref,
    onMounted
} from "vue";
import {
    useRouter
} from 'vue-router';
import Loader from "@/components/Loader";
import axios from "axios";
console.log(localStorage);
export default {
    components: {
        Loader
    },
    setup() {
        let base_url = "http://api.streamly.com/uploads/";
        const router = useRouter();
        let OTPParams = ref({
            n1: '',
            n2: '',
            n3: '',
            n4: '',
            n5: '',
            n6: ''
        });
        let forgotEmail = localStorage.getItem("forgot_email") || "";
        let forgotOTP = localStorage.getItem("forgot_otp") || "";

        const forgotCheckOTP = async () => {
            $('.login-btns').attr('disabled', true);
            window.showHideMainLoader(true);
            let currOTP = OTPParams.value.n1 + OTPParams.value.n2 + OTPParams.value.n3 + OTPParams.value.n4 + OTPParams.value.n5 + OTPParams.value.n6;
            if (currOTP === forgotOTP) {
                router.push("/forgot-password/new-password");
            } else {
                showToast('false', 'Invalid OTP!');
                return false;
            }
        }

        // jQuery logic after Vue renders
        setTimeout(() => {
            $(".inputs input").on("input", function () {
                if (this.value.length === 1) {
                    $(this).next("input").focus();
                }
            });

            $(".inputs input").on("keydown", function (e) {
                if (e.key === "Backspace" && this.value === "") {
                    $(this).prev("input").focus();
                }
            });
        }, 0);

        const forgotSubmit = async () => {
            $('.login-btns').attr('disabled', true);
            window.showHideMainLoader(true);
            const postFormData = new FormData();
            postFormData.append('email', forgotEmail);
            await axios
                .post(axios.defaults.baseUrl + "forgotPassword",
                    postFormData
                )
                .then((response) => {
                    // console.log(response);
                    localStorage.setItem("forgot_user_id", response.data.data.userData.id);
                    localStorage.setItem("forgot_email", response.data.data.userData.email);
                    localStorage.setItem("forgot_otp", response.data.data.otp);
                    localStorage.setItem("forgot_phone", response.data.data.phone_no);
                    router.push('/forgot-password/otp-sent');
                    window.showHideMainLoader(false);
                    // $('.login-btns').removeAttr('disabled');
                })
                .catch((error) => {
                    window.showHideMainLoader(false);
                    showToast(error.response.data.status, error.response.data.message);
                    $('.login-btns').removeAttr('disabled');
                    return false;
                });
        }
        const showToast = (toastIcon, toastMessage) => {
            window.toast.fire({
                icon: toastIcon,
                title: toastMessage,
            });
        }
        onMounted(() => {
            $(".inputs input").first().focus();
            setTimeout(() => {
                window.showHideMainLoader(false);
            }, 500);
        });

        return {
            base_url,
            forgotSubmit,
            forgotCheckOTP,
            forgotEmail,
            forgotOTP,
            OTPParams,
            showToast
        };
    },
};
</script>
